import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const fetchSite = () => axios.get(`${API}/site`).then((r) => r.data);

export const fetchLoans = () => axios.get(`${API}/loans`).then((r) => r.data);

export const fetchLoan = (slug) => axios.get(`${API}/loans/${slug}`).then((r) => r.data);

export const fetchApplyConfig = () => axios.get(`${API}/apply/config`).then((r) => r.data);

export const uploadDoc = (file, docKey, product, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("doc_key", docKey);
  fd.append("product", product);
  return axios.post(`${API}/apply/upload`, fd, {
    onUploadProgress: (e) => e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  }).then((r) => r.data);
};

export const removeDoc = (fileId) => axios.delete(`${API}/apply/upload/${fileId}`);

export const submitApplication = (payload) => axios.post(`${API}/apply`, payload).then((r) => r.data);

export const sendOtp = (mobile) => axios.post(`${API}/apply/otp/send`, { mobile }).then((r) => r.data);

export const verifyOtp = (mobile, code) => axios.post(`${API}/apply/otp/verify`, { mobile, code }).then((r) => r.data);

export const fetchCalculators = () => axios.get(`${API}/calculators`).then((r) => r.data);

export const fetchCalculator = (slug) => axios.get(`${API}/calculators/${slug}`).then((r) => r.data);

export const fetchLegal = (slug) => axios.get(`${API}/legal/${slug}`).then((r) => r.data);

export const submitContact = (body) => axios.post(`${API}/contact`, body).then((r) => r.data);

export const submitDeletion = (body) => axios.post(`${API}/data-deletion`, body).then((r) => r.data);

export const submitLead = (payload) => axios.post(`${API}/leads`, payload).then((r) => r.data);

export const leadError = (err) => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return "Something went wrong. Please try again.";
};

export const fetchPartners = (product) => axios.get(`${API}/partners/${product}`).then((r) => r.data);

export const logPartnerClick = (lead_id, partner_id, token) => axios.post(`${API}/partners/click`, { lead_id, partner_id, token }).then((r) => r.data);

export const fetchCompareIndex = () => axios.get(`${API}/compare`).then((r) => r.data);

export const fetchCompare = (product, limit = 0) => axios.get(`${API}/compare/${product}`, { params: limit ? { limit } : {} }).then((r) => r.data);
